import { render, staticRenderFns } from "./CustomBox.vue?vue&type=template&id=3a5c8d26&"
import script from "./CustomBox.vue?vue&type=script&lang=js&"
export * from "./CustomBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports